module.exports = __webpack_public_path__ + "static/media/Muslimov.78222f7a.png";